function init() {
    let container = document.querySelector(".translucent-header");
    if (!container) return;

    let imageContainer = container.querySelector(".container-image-list");
    let videoElement = container.querySelector(".hero__video");
    let images = imageContainer ? imageContainer.querySelectorAll("img") : [];

    let currentIndex = 0;
    let isPaused = false;

    const playButton = container.querySelector("#playButton");
    const pauseButton = container.querySelector("#pauseButton");
    let intervalId;

    // --- Ocultar por defecto ---
    playButton.classList.add("hidden");
    pauseButton.classList.add("hidden");

    function showImage(index) {
        images.forEach((img, i) => {
            img.classList.toggle("active", i === index);
        });
    }

    function startSlideshow() {
        intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % images.length;
            showImage(currentIndex);
        }, 3000);
    }

    function stopSlideshow() {
        clearInterval(intervalId);
    }

    function toggleButtons() {
        playButton.classList.toggle("hidden", !isPaused);
        pauseButton.classList.toggle("hidden", isPaused);
    }

    function togglePlayback() {
        if (videoElement && videoElement.tagName.toLowerCase() === "video") {
            if (isPaused) {
                videoElement.play();
            } else {
                videoElement.pause();
            }
        }
    }

    // --- Lógica para mostrar botones solo si hay imágenes múltiples o video normal ---
    const showControls = images.length > 1 || (videoElement && videoElement.tagName.toLowerCase() === "video");

    if (showControls) {
        pauseButton.classList.remove("hidden");
    }

    // --- Configuración según tipo de contenido ---
    if (videoElement && videoElement.tagName.toLowerCase() === "iframe") {
        playButton.classList.add("hidden");
        pauseButton.classList.add("hidden");
    }

    if (images.length === 1) {
        let imageUrl = images[currentIndex].src;
        container.style.backgroundImage = `url(${imageUrl})`;
        // Botones ocultos, ya están por defecto
    } else if (images.length > 1) {
        showImage(currentIndex);
        startSlideshow();

        playButton.addEventListener("click", () => {
            if (isPaused) {
                startSlideshow();
                togglePlayback();
                isPaused = false;
                toggleButtons();
            }
        });

        pauseButton.addEventListener("click", () => {
            if (!isPaused) {
                stopSlideshow();
                togglePlayback();
                isPaused = true;
                toggleButtons();
            }
        });
    } else if (videoElement && videoElement.tagName.toLowerCase() === "video") {
        playButton.addEventListener("click", () => {
            if (isPaused) {
                videoElement.play();
                isPaused = false;
                toggleButtons();
            }
        });

        pauseButton.addEventListener("click", () => {
            if (!isPaused) {
                videoElement.pause();
                isPaused = true;
                toggleButtons();
            }
        });
    }
}

export default { init };
